/**
 * CrossBorder.jsx — Subtab XII
 */

import React from "react";
import { HubSpoke } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function CrossBorder() {
  return (
    <article>
      <SubtabHeading roman="XII">Cross-Border Deployment and Data Residency</SubtabHeading>
      <HubSpoke />
      <GapBlock>
        Engaging firms have international offices. GDPR has data residency
        requirements. Some clients require data to remain within specified
        jurisdictions.
      </GapBlock>
      <SolutionLead>
        A hub-and-spoke deployment architecture with regional air-gapped
        instances.
      </SolutionLead>
      <Body>
        <P>
          CoConsoleX operates regional instances in the major jurisdictions
          where its engaging firms have offices and where client data residency
          requires local processing — typically US (East and West coasts), EU
          (Frankfurt or Dublin), and UK (London). Each regional instance is
          independently air-gapped; data does not flow between regions. A
          matter that touches multiple jurisdictions is handled either by
          routing all work to a single instance (the engaging firm's choice)
          or by federated work where each jurisdiction's portion is handled
          in-region with manual coordination by the supervising attorneys.
        </P>
        <P>
          GDPR compliance is satisfied by data minimization (only
          matter-relevant data is processed), purpose limitation (engagement
          scope defines processing purpose), storage limitation (data is
          destroyed at engagement close), and the lawful basis of contractual
          necessity (the engagement letter is the contract). CaseSignalHQ
          publishes a model GDPR Article 28 processor agreement, even though
          CoConsoleX is arguably a controller-controller relationship rather
          than processor — getting this categorization right matters and
          turns on whether CoConsoleX is exercising independent legal judgment
          (which it is, by design).
        </P>
        <P>
          For Asia-Pacific work, Singapore and Tokyo are the realistic
          regional hubs. Hong Kong is increasingly difficult for
          confidentiality reasons. Mainland China is a non-starter for most
          US and EU clients. CoConsoleX is honest about geographic scope
          rather than promising global coverage that can't credibly be
          delivered.
        </P>
        <P>
          For UK work post-Brexit, the UK GDPR applies and the UK has its own
          data adequacy regime. A UK-based instance simplifies this
          significantly.
        </P>
      </Body>
    </article>
  );
}
